import React from 'react';
import Sidebar from '../BasicComponents/Sidebar';
import DashboardHeader from '../BasicComponents/DashboardHeader';
import StatCard from '../BasicComponents/StatCard';

const AdminDashboard = () => {
 return (
 <div className="flex bg-[#0d0d0d] min-h-screen">
 <Sidebar />

 <div className="flex-1 p-6">
 {/* Glow Box Wrapper */}
 <div
 className="relative bg-[#111] text-white rounded-2xl p-10 border border-secondary shadow-lg z-10"
 style={{
 boxShadow:"0 0 60px rgba(255, 215, 0, 0.3), 0 0 20px rgba(0,0,0,0.6)",
 }}
 >
 <DashboardHeader />

 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
 <StatCard
 title="Total Users"
 value="8,765"
 //description="+5% since last week"
 color="text-green-400"
 />
 <StatCard
 title="Code Submissions"
 value="12,534"
 description="+8% active users"
 color="text-blue-400"
 />
 <StatCard
 title="Challenges Active"
 value="23"
 description="No change"
 color="text-primary"
 />
 </div>

 <div className="mt-10 bg-[#1a1a1a] p-6 rounded-xl">
 <h3 className="text-xl text-gray-50 font-semibold mb-4">Recent Activity</h3>
 <ul className="space-y-3 text-muted text-sm">
 <li>✔️ User <span className="text-gold">Dharani</span> solved"Array Sorting Challenge"</li>
 <li>⚙️ Admin updated settings for weekly leaderboard</li>
 <li>🔍 User <span className="text-gold">Sami</span> submitted code for"Level 8 Project"</li>
 <li>⚔️ New challenge"React Speedrun" launched</li>
 </ul>
 </div>

 </div>
 </div>
 </div>
 );
};

export default AdminDashboard;



